import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { ITableServerResponseFilter } from '../../../common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from '../../../common/interfaces/table/table-server-filter.inteface';
import { AbstractAutoDisbursementService } from '../abstraction/abstract.auto-disbursement.service';

@Injectable({
  providedIn: 'root',
})
export class AutoDisbursementService extends AbstractAutoDisbursementService {
  controller = `/manager/rtp/autodisbursement`;
  urlGetAutoDisbursementGrid = `${environment.apiUrl}${this.controller}/grid`;
  urlGetAutoDisbursementExportExcel = `${environment.apiUrl}${this.controller}/gridExportExcel`;
  urlGetAutoDisbursementExportCSV = `${environment.apiUrl}${this.controller}/gridExportCSV`;

  override tableFilter(
    filter: ITableServerFilter
  ): Promise<ITableServerResponseFilter | undefined> {
    return this.http
      .post<ITableServerResponseFilter>(`${this.urlGetAutoDisbursementGrid}`, filter)
      .toPromise();
  }
  override tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    return this.http
      .post(`${this.urlGetAutoDisbursementExportCSV}`, filter, {
        responseType: 'blob',
      })
      .toPromise();
  }
  override tableExportExcel(filter: ITableServerFilter): Promise<any> {
    return this.http.post(`${this.urlGetAutoDisbursementExportExcel}`, filter).toPromise();
  }
  constructor(private http: HttpClient) {
    super();
  }
}
